import api from '~/services/api';
import Store, { StoreName } from '~/types/Store';
import { decamelizeKeys } from '~/utils/humps';

function fetchStores() {
  return api.get('ui/stores?connected=True&results=50');
}

function fetchLegacyStores() {
  return api.get('ui/shops');
}

function disconnectStore(storeName: StoreName, objectId: string) {
  return api.post('ui/stores/disconnect', {
    store_name: storeName,
    object_id: objectId,
  });
}

function editStore(store: Store) {
  return api.put(`ui/stores/${store.objectId}`, {
    ...decamelizeKeys(store),
  });
}

export { fetchStores, fetchLegacyStores, disconnectStore, editStore };
